const BASE_URL =
  process.env.REACT_APP_FEEDBACKS_API_URL ||
  "https://control-point-admin.vercel.app";

const FEEDBACKS_URL = `${BASE_URL}/api/public/feedbacks`;

// Busca todos os feedbacks publicados, percorrendo as páginas (máx. 50 por página)
export async function getFeedbacks() {
  const all = [];
  let page = 1;
  let totalPages = 1;

  do {
    const res = await fetch(`${FEEDBACKS_URL}?page=${page}&limit=50`);
    const json = await res.json();
    if (!res.ok || json.error) {
      throw new Error(json.error?.message || "Não foi possível carregar.");
    }
    all.push(...json.data);
    totalPages = json.meta?.total_pages ?? 1;
    page++;
  } while (page <= totalPages);

  return all;
}

// Envia um feedback; ele só aparece no GET depois de aprovado no painel admin
export async function sendFeedback({ name, jobTitle, message, website }) {
  const res = await fetch(FEEDBACKS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name,
      job_title: jobTitle,
      message,
      website: website ?? "",
    }),
  });

  let json = null;
  try {
    json = await res.json();
  } catch {
    // resposta sem corpo JSON
  }

  if (!res.ok || json?.error) {
    if (res.status === 429) {
      throw new Error("Muitos envios. Tente novamente em alguns minutos.");
    }
    throw new Error(json?.error?.message || "Não foi possível enviar.");
  }
  return true;
}
